import React from "react";
import CategorywiseProducts from "./CategorywiseProducts";

export default function Index() {
  return (
    <>
      <CategorywiseProducts />
    </>
  );
}
